/** Matches backend DriveRequest android minimal version check. */
export const ANDROID_MIN_APP_VERSION = "4.11.5";

export const RIDE_ORDER_REQUEST_CLIENT = {
  app_version: ANDROID_MIN_APP_VERSION,
  device_type: "android",
  platform: "android",
  device_version: "16",
} as const;
